export type ChangelogEntryType = "feature" | "improvement" | "fix" | "other";

export type ChangelogEntry = {
  type: ChangelogEntryType;
  text: string;
};

export type ChangelogRelease = {
  version: string;
  /** ISO date (YYYY-MM-DD) — the date this version was cut. */
  date: string;
  entries: ChangelogEntry[];
};

/**
 * Generated + maintained by `scripts/release.mjs` — DO NOT hand-edit
 * individual releases' wording, since a future `pnpm run release` run
 * regenerates the newest entry from the LLM's own output, not from
 * whatever's here. New releases are PREPENDED (index 0 is always the
 * newest), matching this array's own display order on `/changelog`.
 */
export const CHANGELOG: ChangelogRelease[] = [
  {
    version: "0.1.0",
    date: "2026-07-09",
    entries: [
      { type: "feature", text: "Added a QA Automation section with a dashboard, recent test runs, slowest tests, and highest failure rate views." },
      { type: "feature", text: "Added a Workflows section with a summary dashboard, run history with infinite scroll, and detailed run pages with timelines." },
      { type: "feature", text: "Added a changelog page to track what's new in the app." },
      { type: "improvement", text: "Improved navigation with working links, sidebar entries, and breadcrumbs across all pages." },
    ],
  },];
